import { Form } from 'react-bootstrap';

type SilurianProjectionData = {
  storm_id_dt: string;
  properties: {
    storm_name: string;
  };
};

type SiluririanProjectToggleProps = {
  event: {
    id: string;
    name: string;
    hazard_name: string;
    hazard_data_category: string;
    geometry_type: string;
    instance_id: string;
  };
  layerState: {
    silurianProjectionVisibleToggle: boolean;
    silurianProjectionData: SilurianProjectionData[];
    setSilurianProjectionVisibleToggle: (value: boolean) => void;
  };
};

type FormEvent = {
  target: {
    checked: boolean;
  };
};

const SilurianProjectionToggle = ({
  event,
  layerState,
}: SiluririanProjectToggleProps) => {
  const hasSilurianProjection = layerState?.silurianProjectionData?.some(
    (item) => item.storm_id_dt === event.instance_id
  );
  return (
    <>
      {event.hazard_name === 'Hurricane' && hasSilurianProjection && (
        <Form.Switch
          id="sms-consent-switch"
          label="Experimental AI Track Forecast (Powered by Silurian AI)"
          checked={layerState.silurianProjectionVisibleToggle}
          onChange={(e: FormEvent) =>
            layerState.setSilurianProjectionVisibleToggle(e.target.checked)
          }
        />
      )}
    </>
  );
};

export default SilurianProjectionToggle;
